export * from './AccountTypePage';
